<template>
    <div class="all-index">
        <!-- header -->
        <div class="header">
            <!-- header-logo -->
            <div class="header-logo" :class="navbg" ref="ref_nav">
                <!-- logo -->
                <div class="logo">
                    <div class="logo-img">
                        <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/logo.png" />
                    </div>
                    <div class="logo-font">
                        <span>临研数字化智库平台</span>
                        <!-- <span>成都六人行信息科技有限公司</span> -->
                        <span>Pharma-Inspiration</span>
                    </div>
                </div>
                <!-- nav -->
                <div class="nav">
                    <div class="nav-li" @click="handleClickScroll('header')">首  页</div>
                    <div class="nav-li" @click="handleClickScroll('gyly')">关于临研</div>
                    <div class="nav-li" @click="handleClickScroll('ptts')">平台特色</div>
                    <div class="nav-li" @click="handleClickScroll('zxfw')">咨询服务</div>
                    <div class="nav-li" @click="handleClickScroll('lxwm')">联系我们</div>
                    <div class="to-login">
                        <!-- <el-button plain size="mini" @click="towuxu('login')">立即登录</el-button> -->
                        <el-button plain size="mini" @click="topage('/login')">立即登录</el-button>
                    </div>
                    <div class="to-apply">
                        <!-- <el-button plain size="mini" @click="towuxu('apply')">申请试用</el-button> -->
                        <el-button plain size="mini" @click="topage('/apply')">申请试用</el-button>
                    </div>
                </div>
            </div>
            <!-- banner -->
            <div class="banner">
                <div class="banner-main">
                    <div class="banner-left" id="a-1">
                        <span class="b-one">Pharma-Inspiration</span>
                        <span class="b-two">临床研究数字化先驱者</span>
                        <span class="b-three">集成化、体系化、AI数据算法驱动的临研数据筛选、洞察、追踪与管理，临床数据帮助用户作出最优决策。</span>
                    </div>
                    <div class="banner-right">
                        <img id="a-2" width="430" src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/banner1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="main-index">
            <div class="gyly">
                <div class="gyly-top">
                    <div class="gyly-main" id="a-3">
                        <div class="gm-l">
                            <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/gylyimg1.png" alt="">
                        </div>
                        <div class="gm-r">
                            <span class="gm-r-a">高效监测临床研究竞争态势大数据信息</span>
                            <span class="gm-r-b">Pharma-Inspiration是一个基于科学数据的临床研究综合数据库，包含关于临床试验、申办方、研究中心、研究者、第三方供应商的多维信息关系网，通过前沿大数据AI算法，精准画像，致力于帮助客户及时、准确、全面、高效地监测日益增长的关于临床研究竞争态势大数据信息。</span>
                        </div>
                    </div>
                </div>
                <div class="gyly-bottom">
                    <div class="gyly-main" id="a-4">
                        <div class="gm-l">
                            <span class="gm-l-a">临床大数据帮助用户作出最优决策</span>
                            <span class="gm-l-b">Pharma-Inspiration包含超过160,0000条数据记录，是一个对用户友好的数字化智库平台，用户可以轻松访问由临研专业人士治理的临研情报信息，帮助用户基于临床数据作出最优决策。通过研究产品的精准画像，帮助用户发现研究过程中的各种问题，提供合理化建议和优化的一揽子解决方案</span>
                        </div>
                        <div class="gm-r">
                            <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/dpimg.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="ptts">
                <div class="ptts-main">
                    <div class="ptts-main-top">平台特色</div>
                    <div class="ptts-main-bottom">
                        <div class="ptts-kp">
                            <div class="ptts-tb">
                                <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/ptts-tb1.png" alt="">
                            </div>
                            <span>基于业界信赖的临研数据，服务于临床研发、KOL追踪，获得竞争优势。</span>
                        </div>
                        <div class="ptts-kp">
                            <div class="ptts-tb">
                                <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/ptts-tb2.png" alt="">
                            </div>
                            <span>集成化、体系化、AI数据算法驱动的临研数据筛选、洞察、追踪与管理。</span>
                        </div>
                        <div class="ptts-kp">
                            <div class="ptts-tb">
                                <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/ptts-tb3.png" alt="">
                            </div>
                            <span>通过单一搜索即可获得关于Site、Sponsor、PI、Supplier大数据画像信息。</span>
                        </div>
                        <div class="ptts-kp">
                            <div class="ptts-tb">
                                <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/ptts-tb4.png" alt="">
                            </div>
                            <span>多渠道来源的信息被专业评估和整合，值得您信赖并在第一时间采用。</span>
                        </div>
                        <div class="ptts-kp">
                            <div class="ptts-tb">
                                <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/ptts-tb5.png" alt="">
                            </div>
                            <span>优化临床用时及成本管理，提高投资回报率及研发成功率。</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="zxfw">
                <div class="zxfw-main">
                    <div class="zxfw-main-top">临研咨询服务</div>
                    <div class="zxfw-main-bottom">
                        <div class="zxfw-kp yybg1">
                            <span>临研竞争格局与开发规划评估</span>
                        </div>
                        <div class="zxfw-kp yybg2">
                            <span>研究中心与研究者筛选评估</span>
                        </div>
                        <div class="zxfw-kp yybg3">
                            <span>潜在受试者资源与疾病评估</span>
                        </div>
                        <div class="zxfw-kp yybg4">
                            <span>CXO供应商第三方独立调研评估</span>
                        </div>
                        <div class="zxfw-kp yybg5">
                            <span>临床项目预测性分析与决策建议</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lxwm">
                <div class="lxwm-main">
                    <div class="lxwm-main-top">
                        <div class="lxwm-title-en" id="a-5">
                            Pharma-Inspiration
                        </div>
                        <div class="lxwm-title-cn" id="a-6">
                            临床研究数字化先驱者
                        </div>
                        <div class="lxwm-desc" id="a-7">
                            在Pharma Inspiration的帮助下, 您将始终站在瞬息万变的新药研发最前沿,做出最优决策!
                        </div>
                    </div>
                </div>
            </div>
            <div class="yqlj">
                <div class="yqlj-main">
                    <div class="left">
                        <div class="title-index">客服热线：133-7278-0965 邮箱：xry@wuxuwang.com</div>
                        <div class="beian">
                                <span>重庆药达大数据有限公司 Copyright © 2020 All Rights Reserved. </span>
                            
                                <a href="http://beian.miit.gov.cn/" target="_blank">渝ICP备2024020240号-2 <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/beiantb.png"></a>
                        </div>
                    </div>
                    <div class="right">
                        <img src="https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/wxgzh.png" alt="">
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Velocity from "velocity-animate";
export default {
    name: "index",
    data() {
        return {
            scrollComplete: true,
            navbg:'',
            am: {
                header: true,
                gyly: true,
                zxfw: true,
            }
        };
    },
    computed: {
    },
    methods: {
        // 点击滚动
        handleClickScroll(cname) {
            this.toAnimate(cname)
            let vm = null;
            vm = document.getElementsByClassName(cname);
            let titleHeight = this.$refs.ref_nav.offsetHeight;
            Velocity(vm, "stop");
            Velocity(vm, "scroll", {
                duration: 300,
                offset: -titleHeight,
                easing: "easeOutQuart",

                mobileHA: false,
                begin: () => {
                    this.scrollComplete = false;
                },
                complete: () => {
                    this.scrollComplete = true;
                },
            });
        },
        handleUserScroll(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop>60) {
                this.navbg = 'navbg'
            }else{
                this.navbg = ''; 
            } 
            if (scrollTop>0 && scrollTop<300) {
                this.toAnimate('header')
            }else if (scrollTop>300 && scrollTop<1320) {
                this.toAnimate('gyly');
            }else if (scrollTop>1320 && scrollTop<1820) {
                // 不执行任何操作
                return;
            }else if(scrollTop>1820 && scrollTop<2048){
                this.toAnimate('zxfw')
            }else{ 
                // 注释掉只触发一次
                // this.am.header = true;
                // this.am.gyly = true;
                // this.am.zxfw = true;
            }
        },
        // 初始化动画
        initHeader(){
            let a1 = document.getElementById('a-1');
            let a2 = document.getElementById('a-2');
            Velocity(a1,{'margin-left': [0,-800]},{duration: 1500});
            Velocity(a2,{'margin-left': [0,800]},{duration: 1500});
        },
        // 触发动画
        toAnimate(cname = null){
            if (cname == 'header' && this.am.header) {
                // this.am.header = false;
                // let a1 = document.getElementById('a-1');
                // let a2 = document.getElementById('a-2');
                // Velocity(a1,{'margin-left': [0,-800]},{duration: 1500});
                // Velocity(a2,{'margin-left': [0,800]},{duration: 1500});
            }else if (cname=='gyly' && this.am.gyly) {
                this.am.gyly = false;
                let a3 = document.getElementById('a-3');
                let a4 = document.getElementById('a-4');
                Velocity(a3,{'left': [0,2000]},{duration: 1500});
                Velocity(a4,{'right': [0,2000]},{duration: 1500});
            }else if (cname=='zxfw' && this.am.zxfw) {
                // this.am.zxfw = false;
                // let a5 = document.getElementById('a-5');
                // let a6 = document.getElementById('a-6');
                // let a7 = document.getElementById('a-7');
                // Velocity(a5,{'left': [0,2000]},{duration: 800});
                // Velocity(a6,{'right': [0,2000]},{duration: 800});
                // Velocity(a7,{'left': [0,2000]},{duration: 800});
            }
        },
        // 跳转到戊戌进行登录
        towuxu(tp=''){
            this.$common.towuxu(tp);
        },
        topage(path = '') {
            this.$router.push({ path: path })
        }
    },
    created() {
        window.addEventListener("scroll", this.handleUserScroll);
        this.$nextTick(()=>{
            //  banner1的动态效果
            this.initHeader();
        })
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleUserScroll);
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/base.less";
.all-index{
    min-width: 1200px;
    font-family: Microsoft Yahei,PingFang SC,Verdana,Helvetica Neue,Hiragino Sans GB,"Microsoft Sans Serif",WenQuanYi Micro Hei,"sans-serif";
}
.navbg{
    background: #20c2c2;
}
.header{
    height: 560px;
    background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/navbg.png) center center no-repeat;
    background-size: cover;
    .header-logo{
        width: 100%;
        height: 60px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        position: fixed;
        top: 0;
        z-index: 9;
        // logo
        .logo{
            width: 280px;
            height: 60px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .logo-img{
                width: 80px;
                height: 45px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                img{
                    width: 70px;
                }
            }
            .logo-font{
                width: 200px;
                height: 50px;
                color: #FFF;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-end;
                align-content: flex-start;
            }
        }
        // 导航
        .nav{
            width: 650px;
            height: 60px;
            font-size: 14px;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            .nav-li{
                width: 80px;
                color: #FFF;
                cursor: pointer;
            }
            .to-login{
                padding-right: 10px;
                .el-button{
                    background: #2f4858;
                    border: 1px solid #2f4858;
                }
                .el-button span{
                    font-size: 14px;
                    font-weight: bold;
                    color: #FFF;
                }
            }
            .to-apply{
                padding-right: 10px;
                .el-button{
                    background: #ff9139;
                    border: 1px solid #ff9139;
                }
                .el-button span{
                    font-size: 14px;
                    font-weight: bold;
                    color: #FFF;
                }
            }
        }
    }
    .banner{
        width: 100%;
        height: 500px;
        padding-top: 80px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        .banner-main{
            width: 1000px;
            height: 400px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .banner-left{
                width: 500px;
                height: 250px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin-top: 68px;
                span{
                    margin-top: 5px;
                }
                span.b-one{
                    color: #FFFFFF;
                    font-weight: 300;
                    font-size: 35px;
                }
                span.b-two{
                    color: #FFFFFF;
                    font-weight: bold;
                    font-size: 40px;
                }
                span.b-three{
                    color: #FFFFFF;
                    line-height: 24px;
                    font-size: 14px;
                }
            }
            .banner-right{
                width: 400px;
                height: 250px;
            }
        }
    }
}
.main-index{
    .gyly{
        .gyly-top{
            height: 410px;
            background: #F5F5F5;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            .gyly-main{
                position: relative;
                width: 1000px;
                height: 330px;
                display: flex;
                flex-direction: row;
                align-items: center;
                .gm-r{
                    padding-left: 80px;
                    padding-top: 73px;
                    display: flex;
                    flex-direction: column;
                    span.gm-r-a{
                        background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/tybg1.png) left center no-repeat;
                        color: #333333;
                        font-size: 35px;
                        font-weight: 300;
                        padding-left: 28px;
                        height: 72px;
                        line-height: 81px;
                    }
                    span.gm-r-b{
                        padding-top: 10px;
                        color: #333333;
                        font-size: 14px;
                        font-weight: 300;
                        line-height: 30px;
                        padding-left: 20px;
                    }

                }
            }
        }
        .gyly-bottom{
            height: 410px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            .gyly-main{
                position: relative;
                width: 1000px;
                height: 330px;
                display: flex;
                flex-direction: row;
                align-items: center;
                .gm-l{
                    padding-right: 80px;
                    padding-top: 55px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    span.gm-l-a{
                        background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/tybg2.png) right center no-repeat;
                        color: #333333;
                        font-size: 35px;
                        font-weight: 300;
                        padding-right: 28px;
                        height: 72px;
                        line-height: 81px;
                    }
                    span.gm-l-b{
                        padding-top: 10px;
                        color: #333333;
                        font-size: 14px;
                        font-weight: 300;
                        line-height: 30px;
                        padding-right: 20px;
                    }

                }
            }
        }
    }
    .ptts{
        width: 100%;
        height: 500px;
        background: #2F4858;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .ptts-main{
            min-width: 1000px;
            height: 360px;
            .ptts-main-top{
                height: 80px;
                line-height: 10px;
                text-align: center;
                font-size: 35px;
                font-weight: bold;
                color: #FFFFFF;
            }
            .ptts-main-bottom{
                width: 1060px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .ptts-kp{
                    width: 201px;
                    height: 274px;
                    background: #FFFFFF;
                    border-radius: 3px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    transition: 3s;
                    .ptts-tb{
                        height: 120px;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                    }
                    span{
                        width: 171px;
                        height: 120px;
                        font-size: 14px;
                        font-weight: 300;
                        color: #2F4858;
                        line-height: 24px;
                        display: flex;
                        align-items: flex-start;
                        flex-direction: column;
                        justify-content: flex-start;
                    }
                }
                .ptts-kp:hover{
                    margin-top: -25px;
                    transition: 0.5s;
                }
            }
        }
    }
    .zxfw{
        width: 100%;
        height: 500px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .zxfw-main{
            min-width: 1000px;
            height: 360px;
            .zxfw-main-top{
                height: 80px;
                line-height: 80px;
                text-align: center;
                font-size: 35px;
                font-weight: bold;
                color: #21C1C4;
            }
            .zxfw-main-bottom{
                width: 1000px;
                margin-top: 25px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .zxfw-kp{
                    width: 180px;
                    height: 180px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    span{
                        width: 150px;
                        height: 43px;
                        color: #2F4858;
                        line-height: 30px;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 400;
                        color: #FFFFFF;
                    }
                }
                .yybg1{
                    background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/yybg1.png) center center no-repeat;
                }
                .yybg2{
                    background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/yybg2.png) center center no-repeat;
                }
                .yybg3{
                    background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/yybg3.png) center center no-repeat;
                }
                .yybg4{
                    background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/yybg4.png) center center no-repeat;
                }
                .yybg5{
                    background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/yybg5.png) center center no-repeat;
                }
                .zxfw-kp:hover{
                    transform:rotate(360deg);
                    transition: transform 0.5s;
                }
            }
        }
    }
    .lxwm{
        width:100%;
        height: 442px;
        background: url(https://digitalgcp.oss-cn-hangzhou.aliyuncs.com/static/home/index/hlxgbg.png) center center no-repeat;
        .lxwm-main{
            width: 100%;
            height: 442px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .lxwm-main-top{
                width: 1000px;
                height: 175px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                .lxwm-title-en{
                    position: relative;
                    font-size: 35px;
                    font-weight: bold;
                    color: #FFFFFF;
                }
                .lxwm-title-cn{
                    position: relative;
                    font-size: 42px;
                    font-weight: bold;
                    color: #FFFFFF;
                }
                .lxwm-desc{
                    position: relative;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }
    }
    .yqlj{
        width: 100%;
        height: 150px;
        background: #2F4858;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;
        justify-content: center;
        .yqlj-main{
            min-width: 1200px;
            height: 150px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .left{
                width: 1100px;
                color: #f6f6f6;
                line-height: 25px;
                .title-index{
                    font-weight: bold;
                }
                a,span{
                    color: #f6f6f6;
                    line-height: 25px;
                }
            }
            .right{
                width: 100px;
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
        }
    }
}
</style>
